import { Component, OnInit, ViewChild } from '@angular/core';
import { CursoService } from "../../servicios/curso.service";
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/servicios/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CursoUsuarioService } from 'src/app/servicios/curso-usuario.service';



@Component({
  selector: 'app-reproducir-curso',
  templateUrl: './reproducir-curso.component.html',
  styleUrls: ['./reproducir-curso.component.scss']
})
export class ReproducirCursoComponent implements OnInit {

  public videos=[];
  public curso$:Observable<any>;
  public si=false;
  public nombreCurso:string;
  public link;
 

  constructor(public cursoSvc:CursoService, private userSvc:AuthService,
             private route:ActivatedRoute, private AuthSvc:AuthService,
             private curUserSvc:CursoUsuarioService, private router:Router) { }

   ngOnInit() {
    let id = this.route.snapshot.params.id;
    this.cursoSvc.getOneCurso(id).subscribe(res=>
      {
        //console.log(res);
        this.videos = res.videos;
      })

    //si el usuario no compro el curso lo pateo...
    //creo variable de verificacion
    let dejoEntrar = false;

    //veo todos los cursos comprados
    this.curUserSvc.getAllUsuarioCurso().subscribe(res=>
      {
        let cursosUsuarios = res

        //veo la info del usuario actual
        this.curUserSvc.verUserData().subscribe(res=>
        {
          //console.log(res);
          //recorro todos los cursos comprados
          cursosUsuarios.forEach(element => {
            //si el usuario actual compro este curso, entnces lo dejo entrar, sino lo mmando al lobi
            if(element.data.usuario == res.uid && element.data.curso == id)
            {
              //console.log("entro jejejejejejejeje");
              dejoEntrar = true;
            }
        });
        })
      })
      //**********FIN DEL DEJO ENTRAR */

      setTimeout(() => 
    {      
      this.videos.sort(function(v1,v2)
      {
        if(v1 < v2)
        {
          return -1
        }
        else if(v1 > v2)
        {
          return 1
        }
        return 0
      });
      //console.log(this.videos);
      if (!dejoEntrar) {
        this.router.navigate(["/**"])
      }
      this.si = true;
    },
    3000); 

      
   
  }//fin OnInit


 
  openVideo(video, index) {
    // Declare all variables
    var i, tabcontent, tablinks;
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    
    //diseño
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].style.backgroundColor = "#09111c"
    }
    

    document.getElementById(index).style.backgroundColor = "#2c2952";
    // Get all elements with class="tablinks" and remove the class "active"
 
  
    // Show the current tab, and add an "active" class to the link that opened the tab
    document.getElementById(video).style.display = "block";
  }

  enviar()
  {
    if(this.link == undefined || this.link == "")
    {
      alert("por favor ingrese el link")
    }
    else
    {
      //console.log("curso: ", this.route.snapshot.params.id);
      

      this.curUserSvc.subirLink(this.link,this.route.snapshot.params.id)
      alert("gracias por enviar, pronto sera corregido!");
      this.link = "";
    }
    
    
  }

}
